import classApi from '../../Api/classApi';
import store from '../../redux/store';
import { showError, upgradeSubscriptionDialog } from '../../redux/actions';
import { GA_EVENT_TREE } from '../../gaConstants';

/**
 * Creates a group called `name` and opens its board. Shared by every place a
 * group can be started from (the home page, the groups page, the welcome page)
 * so they all handle the outcomes the same way: a 403 carrying alternative
 * subscriptions opens the upgrade dialog and parks the user on the groups
 * page; anything else shows the generic error toast. Resolves to whether a
 * group was created.
 */
export default function createGroupAndOpen(name, history) {
    const trimmed = (name || '').trim();
    if (!trimmed) return Promise.resolve(false);

    window.logAppActivity(GA_EVENT_TREE.manageGroups.actions.create);
    return classApi
        .createGroup({ name: trimmed })
        .then((res) => {
            history.push('/lesson/' + res.data.id);
            return true;
        })
        .catch((err) => {
            if (!err.response) {
                store.dispatch(showError('GENERIC_ERROR'));
                console.error(err);
                return false;
            }
            if (err.response.status === 401) return false;
            if (err.response.status === 403 && err.response.data?.availableSubscriptions) {
                store.dispatch(
                    upgradeSubscriptionDialog({
                        key: 'subscription.upsell.groups.exceeded',
                        subscriptions: err.response.data?.availableSubscriptions,
                    })
                );
                history.replace('/manageClasses');
            } else {
                store.dispatch(showError('GENERIC_ERROR'));
                console.error(err);
            }
            return false;
        });
}
